import { render } from "./TwoColumnPageLayout.vue?vue&type=template&id=5233ab70"
import script from "./TwoColumnPageLayout.vue?vue&type=script&lang=js"
export * from "./TwoColumnPageLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__